import { customizedFmt, fmt } from 'components/IntlWrapper/IntlWrapper';
import { getUserCurrency } from 'constants/countries/countries-mapping';
import { LOCALE } from 'constants/intl-wrapper';
import { getStoreName } from 'utils/sllr-store';
import { renderFullPickUpAddress } from 'utils/pickups';

import {
  PRIVACY_POLICY_CONTENT,
  PRIVACY_POLICY_CONTENT_AR,
  TERMS_AND_CONDITIONS_CONTENT,
  TERMS_AND_CONDITIONS_CONTENT_AR,
  SHIPPING_CONTENT,
  SHIPPING_CONTENT_AR,
  RETURNS_POLICY_CONTENT,
  RETURNS_POLICY_CONTENT_AR,
  CONTACT_US_CONTENT,
  CONTACT_US_CONTENT_AR,
  PAYMENT_METHODS_CONTENT,
  PAYMENT_METHODS_CONTENT_AR
} from './page-templates-content';

const PAGES_TEMPLATES_KEYS = {
  PRIVACY_POLICY: 'privacy_policy',
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  SHIPPING: 'shipping',
  RETURNS_POLICY: 'returns_policy',
  CONTACT_US: 'contact_us',
  PAYMENT_METHODS: 'payment_methods'
};

export const PAGES_TEMPLATES_OPTIONS_KEYS = [
  PAGES_TEMPLATES_KEYS.PRIVACY_POLICY,
  PAGES_TEMPLATES_KEYS.TERMS_AND_CONDITIONS,
  PAGES_TEMPLATES_KEYS.SHIPPING,
  PAGES_TEMPLATES_KEYS.RETURNS_POLICY,
  PAGES_TEMPLATES_KEYS.CONTACT_US,
  PAGES_TEMPLATES_KEYS.PAYMENT_METHODS
];

export const getPageTemplate = ({ templateKey, businessInfo }) => {
  const { EN, AR } = LOCALE;
  const {
    storeInfo,
    featuresConfigurations,
    userLoggedInInfo,
    name: businessName,
    arabicName: businessNameAr,
    defaultPickupLocation
  } = businessInfo || {};
  const {
    storeName,
    storeNameAr,
    storeContactNumber,
    socialLinks,
    returnPolicy,
    shippingConfig,
    estimatedDeliveryDate
  } = storeInfo || {};
  const { isOnlinePaymentEnabled } = featuresConfigurations || {};
  const { emails, businessAdminInfo } = userLoggedInInfo || {};
  const { businessLegalInfo } = businessAdminInfo || {};

  const name = getStoreName({ storeName, storeNameAr, lang: EN });
  const nameAr = getStoreName({ storeName, storeNameAr, lang: AR });
  const address = renderFullPickUpAddress({
    address: defaultPickupLocation?.address,
    lang: EN
  });
  const addressAr = renderFullPickUpAddress({
    address: defaultPickupLocation?.address,
    lang: AR
  });
  const email = emails?.[0]?.address;

  const termsAndPermissionsProps = {
    email,
    storeContactNumber,
    vatId: businessLegalInfo?.vatId
  };

  const currency = fmt({
    id: `common.currency.${getUserCurrency()}`
  });

  const currencyAr = customizedFmt(AR)({
    id: `common.currency.${getUserCurrency()}`
  });

  const {
    PRIVACY_POLICY,
    TERMS_AND_CONDITIONS,
    SHIPPING,
    RETURNS_POLICY,
    CONTACT_US,
    PAYMENT_METHODS
  } = PAGES_TEMPLATES_KEYS;

  const PAGES_TEMPLATES = {
    [PRIVACY_POLICY]: {
      content: PRIVACY_POLICY_CONTENT(name),
      contentAr: PRIVACY_POLICY_CONTENT_AR(nameAr)
    },
    [TERMS_AND_CONDITIONS]: {
      content: TERMS_AND_CONDITIONS_CONTENT({
        storeName: name,
        businessName: businessName || businessNameAr,
        address,
        ...termsAndPermissionsProps
      }),
      contentAr: TERMS_AND_CONDITIONS_CONTENT_AR({
        storeName: nameAr,
        businessName: businessNameAr || businessName,
        address: addressAr,
        ...termsAndPermissionsProps
      })
    },
    [SHIPPING]: {
      content: SHIPPING_CONTENT({
        shippingConfig,
        estimatedDeliveryDate,
        currency,
        storeContactNumber
      }),
      contentAr: SHIPPING_CONTENT_AR({
        shippingConfig,
        estimatedDeliveryDate,
        currency: currencyAr,
        storeContactNumber
      })
    },
    [RETURNS_POLICY]: {
      content: RETURNS_POLICY_CONTENT({
        returnPolicy,
        currency
      }),
      contentAr: RETURNS_POLICY_CONTENT_AR({
        returnPolicy,
        currency: currencyAr
      })
    },
    [CONTACT_US]: {
      content: CONTACT_US_CONTENT({ storeContactNumber, socialLinks, email }),
      contentAr: CONTACT_US_CONTENT_AR({
        storeContactNumber,
        socialLinks,
        email
      })
    },
    [PAYMENT_METHODS]: {
      content: PAYMENT_METHODS_CONTENT(isOnlinePaymentEnabled),
      contentAr: PAYMENT_METHODS_CONTENT_AR(isOnlinePaymentEnabled)
    }
  };

  return PAGES_TEMPLATES[templateKey];
};

export const getSocialMediaLinkId = (link = '') => {
  const splitted = link.split('/');
  const socialName =
    splitted[splitted.length - 1] || splitted[splitted.length - 2];

  return socialName;
};
